export const wellnessLabPrimary = '#63948C'
export const wellnessLabLightBackground = '#F7F7F7'